export default __webpack_public_path__ + "static/media/icon_ilustraciones_selected.dad406e5.svg";